import React, { useEffect, useState } from "react";
import MiniDrawer from "../../component/Layout1";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import RestoreIcon from "@mui/icons-material/Restore";
import { getRemovedUsersAPI, restoreUserAPI } from "../../api/auth";

const Restore = () => {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  const [loading, setLoading] = useState(false);

  const handleUsers = async () => {
    const response = await getRemovedUsersAPI();

    if (response.remote === "success") {
      setUsers(response.data.users || []);
    } else {
      console.log("API Error:", response);
    }
  };

  useEffect(() => {
    handleUsers();
  }, []);

  const handleClickOpen = (id) => {
    setSelectedUserId(id);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirmRestore = async (id) => {
    setLoading(true);

    const response = await restoreUserAPI({ id });

    const { message } = response.data;
    if (response.remote === "success" && message === "User restored") {
      setUsers((prevUsers) => prevUsers.filter((user) => user._id !== id));
    } else {
      console.log("API Error:", response);
    }

    setOpen(false);
    setLoading(false);
  };

  return (
    <MiniDrawer>
      <Box>
        <Box sx={{ margin: "10px 0" }}>
          <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
            Restore User
          </Typography>
        </Box>

        <Box className="FormBox" mb={3}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Member ID</TableCell>
                  <TableCell>Full Name</TableCell>
                  <TableCell>Phone number</TableCell>
                  <TableCell>City</TableCell>
                  <TableCell>Occupation</TableCell>
                  <TableCell>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users && users.length > 0 ? (
                  users.map((user) => (
                    <TableRow
                      key={user.fullName}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {user.memberId}
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={3}>
                          <img src={user.userDetails?.profileImage} alt="" />
                          <p>{user.fullName}</p>
                        </Stack>
                      </TableCell>
                      <TableCell>{user.phoneNumber}</TableCell>
                      <TableCell>{user.city}</TableCell>
                      <TableCell>{user.userDetails.occupation}</TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Link
                            className="btnLink"
                            style={{ background: "#BBDEFB" }}
                            onClick={() => handleClickOpen(user._id)}
                          >
                            <RestoreIcon style={{ color: "primary" }} />
                          </Link>
                          <Dialog open={open} onClose={handleClose}>
                            <DialogContent>
                              <Typography
                                style={{
                                  fontWeight: 500,
                                  fontSize: "18.51px",
                                  lineHeight: "20.36px",
                                }}
                              >
                                Do you really want to restore the user?
                              </Typography>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={handleClose} color="primary">
                                Cancel
                              </Button>
                              <Button
                                onClick={() =>
                                  handleConfirmRestore(selectedUserId)
                                }
                                color="error"
                              >
                                Restore
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <p>No deleted users</p>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </MiniDrawer>
  );
};

export default Restore;
